import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import { Draggable, Droppable } from 'react-beautiful-dnd'

import Typography from '../../UniformComponents/Typography'
import Select from '../form/Select'
import Input from '../form/Input'
import Button from '../../UniformComponents/Button'

import { unescapeHtmlTags } from '../../utils/helpers'

const QuestionsControls = ({ store }) => {
    const {
        filteredQuestions, getTitle, handleSearch, surveyOptions, handleSelectSurvey, survey,
    } = store

    const renderQuestions = () => {
        if (!filteredQuestions || !filteredQuestions.length) return null
        return filteredQuestions
            .map(({ question }, index) => (
                <Draggable
                    key={question.id}
                    draggableId={question.id}
                    index={index}
                    id={question.id}
                >
                    {(provided) => (
                        <div
                            className="dndQuestion possible"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            <div className="draggableQuestion">
                                <div className={`questionColorCode code_${question.metadata.oid}`} />
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-Between' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <i className="fa-solid fa-grip-dots-vertical" />
                                        {unescapeHtmlTags(question.kpiName || getTitle(question))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Draggable>
            ))
    }

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: 20 }}>
            {process.env.SHOW_PPT_SURVE_DROPDOWN && (
                <Select
                    label={i18n.t('breadcrumb_Survey')}
                    options={surveyOptions}
                    onBlur={handleSelectSurvey}
                    value={survey?.surveyId || null}
                />
            )}

            {survey ? (
                <Input
                    label={i18n.t('search')}
                    onChange={handleSearch}
                    placeholder="Search questions"
                />
            ) : (
                <Typography type="tiny">{i18n.t('powerpoint.noSurveyExplainer')}</Typography>
            )}

            <Droppable droppableId="pp-qlist">
                {(provided) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className="questionPanel"
                    >
                        {renderQuestions()}
                    </div>
                )}
            </Droppable>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                <Button
                    label="Presentation settings"
                    onClick={store.handleOpenGlobalSettingsModal}
                    cssClass="regular primary"
                />
                <Button
                    label="Add all questions"
                    onClick={store.handleAddAllQuestions}
                    cssClass="regular tertiary"
                />
                <Button
                    label="Download presentation"
                    onClick={store.save}
                    cssClass="regular primary"
                />
            </div>
        </div>
    )
}

export default observer(QuestionsControls)
